<template>
  <div class="route-board m-2" v-on:click="toggleRoute">
    <span
      class="route-label text-link_darker"
      v-bind:class="{ 'route-open' : isOpen }">
      {{ $t('route_label') }}
    </span>
    <div class="route-wrapper">
      <div v-if="!isOpen" class="route-outline p-3">
        <p class="route-outline-time">
          <span class="is-departure font-bold">{{ departure.format("HH:mm") }}</span>
          <span class="is-arrival font-bold" v-bind:class="{ 'text-red' : this.isNotInTime }">{{ arrival.format("HH:mm") }}</span>
          <span class="text-sm">（{{ duration + this.$t('minute_label') }}）</span>
        </p>
        <ul class="route-outline-point pt-2 text-btn_secondary font-sm">
          <li v-for="(o, index) in outline" v-bind:key="index">
            <span v-if="typeof(o) === 'string'">{{ o }}</span>
            <line-icon v-else :line=o />
          </li>
        </ul>
      </div>
      <route-detail
        v-show=isOpen
        :route=route
        :isNotInTime="this.isNotInTime" />
    </div>
  </div>
</template>

<script>
import RouteDetail from "./RouteDetail"
import LineIcon from "../atoms/LineIcon"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    RouteDetail,
    LineIcon
  },
  props: {
    route: {
      type: Object,
      required: true
    },
    isNotInTime: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    toggleRoute: function () {
      this.isOpen = !this.isOpen
    }
  },
  computed: {
    departure: function () {
      const t = moment(this.route.course.Route.Line[0].DepartureState.Datetime.text)
      return t
    },
    arrival: function () {
      const last = this.route.course.Route.Line.length - 1
      const t = moment(this.route.course.Route.Line[last].ArrivalState.Datetime.text)
      return t
    },
    duration: function () {
      return parseInt(this.route.course.Route.timeOnBoard, 10) + parseInt(this.route.course.Route.timeWalk, 10) + parseInt(this.route.course.Route.timeOther, 10)
    },
    outline: function () {
      const points = this.route.course.points.concat()
      let a = []

      // 最初は路線だけで最後はいらない
      a.push(points.shift().line)
      points.pop()

      points.map((point) => {
        a.push(point.name)
        a.push(point.line)
      })

      return a
    }
  }
}
</script>
